import { Container } from '@mui/material';

import MarkdownPage from '../components/MarkdownPage';

const BenefitsPage = (): JSX.Element => (
  <Container maxWidth="md" style={{ backgroundColor: '#fff' }}>
    <MarkdownPage name="benefits" />
  </Container>
);

export default BenefitsPage;
